import Cookies from 'js-cookie'

const platform = 'organize'
// 园所ID
const OrganizeId = `${platform}_organize_id`
// 校区ID
const CampusId = `${platform}_campus_id`

// App
const sidebarStatusKey = 'sidebar_status'
export const getSidebarStatus = () => Cookies.get(sidebarStatusKey)
export const setSidebarStatus = (sidebarStatus: string) => Cookies.set(sidebarStatusKey, sidebarStatus)

// User
const tokenKey = `${platform}_token`

export const getToken = () => Cookies.get(tokenKey)
export const setToken = (token: string) => Cookies.set(tokenKey, token)
export const removeToken = () => Cookies.remove(tokenKey)

const languageKey = 'language'
export const getLanguage = () => Cookies.get(languageKey)
export const setLanguage = (language: string) => Cookies.set(languageKey, language)

const sizeKey = 'size'
export const getSize = () => Cookies.get(sizeKey)
export const setSize = (size: string) => Cookies.set(sizeKey, size)

// 机构类型
const organizeTypeKey = 'organizeType'
export const getOrganizeType = () => Number(Cookies.get(organizeTypeKey))
export const setOrganizeType = (data: any) => Cookies.set(organizeTypeKey, data)

export function setOrganizeId(organizeId: number|string) {
  return Cookies.set(OrganizeId, String(organizeId))
}
export function getOrganizeId() {
  return Cookies.get(OrganizeId)
}

export function setCampusId(id: number|string) {
  return Cookies.set(CampusId, String(id))
}
export function getCampusId() {
  return Cookies.get(CampusId)
}

export function getCookie(key: string) {
  return Cookies.get(key)
}
